import { SortOrder } from '@getaccept/fried-tofu';
import { LogSortBy } from '../types/log.types';
import type { ListEventLogsArgs } from '../types/log.types';

export default class EventLogsConstants {
  static defaultFilter: ListEventLogsArgs = {
    dealroomId: undefined,
    sortBy: LogSortBy.CreatedAt,
    sortOrder: SortOrder.Desc,
    limit: 200,
    offset: 0,
    timeInterval: undefined,
    participantIds: undefined,
    eventTypes: undefined,
  };
}
